// extracted by mini-css-extract-plugin
module.exports =  {"description":"Wf1hUARNbAls6uxLg4E2"};